import { cn } from 'src/utils/shadcn';

interface SidePanelBodyAttributeProps extends React.HTMLAttributes<HTMLDivElement> {}
const SidePanelBodyAttribute = ({ children, className }: SidePanelBodyAttributeProps) => {
    return <div className={cn(className)}>{children}</div>;
};

interface SidePanelBodyAttributeTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {}
const SidePanelBodyAttributeTitle = ({ children, className }: SidePanelBodyAttributeTitleProps) => {
    return <h4 className={cn('text-sm font-semibold text-gray-500', className)}>{children}</h4>;
};

interface SidePanelBodyAttributeBodyProps extends React.HTMLAttributes<HTMLDivElement> {
    control?: unknown;
    fallbackMessage?: string;
}
const SidePanelBodyAttributeBody = ({
    children,
    control,
    className,
    fallbackMessage,
}: SidePanelBodyAttributeBodyProps) => {
    return control ? (
        <p className={cn('', className)}> {children}</p>
    ) : (
        <p>{fallbackMessage ? fallbackMessage : '-'}</p>
    );
};

export { SidePanelBodyAttribute, SidePanelBodyAttributeTitle, SidePanelBodyAttributeBody };
